// hooks
import { useQuery } from 'react-query';
import { getUsersEmployees } from 'RestAPIs/employees';

const useGetUsersEmployees = (
  { date, onlyFlex },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['usersEmployees', date, onlyFlex],
    async () => {
      const { data } = await getUsersEmployees(date, onlyFlex);
      return data;
    },
    { ...options }
  );
};

export default useGetUsersEmployees;
